module.exports = __webpack_public_path__ + "img/progressSimulation_uncheck.04836098.png";